import React from 'react';
import { useSEO } from '@/hooks/useSEO';
import Header from '@/components/layout/Header';
import { Hero } from '@/components/landing/Hero';
import { HowItWorks } from '@/components/landing/HowItWorks';
import { Features } from '@/components/landing/Features';
import { ProofSection } from '@/components/landing/ProofSection';
import { PrivacyBanner } from '@/components/landing/PrivacyBanner';
import { Testimonials } from '@/components/landing/Testimonials';
import { Pricing } from '@/components/landing/Pricing';
import Footer from '@/components/layout/Footer';
import { MobileAppBanner } from '@/components/landing/MobileAppBanner';

const HomePage: React.FC = () => {
  useSEO({
    title: 'Five AI - Your Personal AI Career Strategist',
    description: 'Transform your career with AI-powered micro-learning in 5 minutes a day. Master communication, networking, AI skills, and executive presence with personalized coaching and daily nudges. Free to start.',
    path: '/',
  });

  return (
    <main id="main-content" className="min-h-screen bg-background" role="main" aria-label="Main content">
      <Header />
      <div className="pt-16">
        <Hero />
      <HowItWorks />
      <Features />
      <ProofSection />
      <PrivacyBanner />
      <Testimonials />
      <Pricing />
        <Footer />
        <MobileAppBanner />
      </div>
    </main>
  );
};

export default HomePage;
